import ActionTypes from "../constants/action_types";

export default function clearLogs() {
  return {
    type: ActionTypes.LOGS_CLEAR.SUCCESS,
  };
}
